import * as React from 'react';
import { QuestionProps, Question } from '../../interfaces';
import { QuestionOption } from '../../models';

export class ScaleRadio extends React.Component<any> {
    public render() {

        let checked = 'radio option';
        if (this.props.option.checked) {
            checked += ' checked';
        }

        return (
            <div className="optionContainer">
                <div className={checked} onClick={this.radioChangeSet()}>
                    <div className="inner">
                        <label>
                            <input type="radio" name={this.props.buttonGroupId} alt={this.props.option.text || '&nbsp;'} />
                        </label>
                    </div>
                </div>
            </div>);
    }

    private radioChange() {
        this.props.callback();
        this.props.option.checked = !this.props.option.checked;
    }

    private radioChangeSet(): ((event: any) => void) {
        return this.radioChange.bind(this);
    }
}

export class ScaleQuestion extends React.Component<QuestionProps> implements Question {
    private LikertScaleLabels = [
        'Almost always not true or not true',
        'Often not true',
        'Sometimes',
        'Often true',
        'Almost always true or true'
    ];

    public render() {
        const buttonGroupId = `radioOptions-${this.props.question.id}`;

        const components = this.props.question.questionOptions
            .sort((a: QuestionOption, b: QuestionOption) => a.sort - b.sort)
            .map((opt: any) => {
                return <ScaleRadio key={opt.id} buttonGroupId={buttonGroupId} option={opt} callback={this.resetOptionsCB()} />;
            });

        const componentsText = this.props.question.questionOptions.map((opt: QuestionOption) => {
            let scaleLabel = opt.text;

            if (opt.sort >= 0 && opt.sort <= 4) {
                scaleLabel = this.LikertScaleLabels[opt.sort];
            }

            return (
                <div key={opt.id} className="optionContainer">
                    <span>{scaleLabel}</span>
                </div>);
        });

        return (
            <div className="scale-question-wrapper question">
                <div className="statement-number">Statement #{this.props.questionNumber}</div>
                <h2>{this.props.question.text}</h2>
                <hr />
                <div className="scale-block">
                    <div className="options">
                        <div className="bg3" />
                        {components}
                    </div>
                    <div className="options">
                        {componentsText}
                    </div>
                </div>
            </div>);
    }

    private resetOptions() {
        this.props.question.questionOptions.map((opt: any) => {
            opt.checked = false;
        });
        this.forceUpdate();
    }

    private resetOptionsCB() {
        return this.resetOptions.bind(this);
    }
}


// WEBPACK FOOTER //
// ./src/components/assessment/ScaleQuestion.tsx